/** @format */
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';

import { useAuth } from '../Hooks/Auth';
import FooterMobile from './FooterMobile';
import Header from './Header';
import Sidebar from './Sidebar';

const Master = ({
  children,
  showSidebar = true,
  containerFullWidth = false,
  showFormSidebar = false,
  sidebarComponent,
  headerFixed = false,
  title = 'سامانه مسابقات فدراسیون زورخانه ای',
}) => {
  const { pathname } = useLocation();
  const { logout, check } = useAuth();
  return (
    <>
      <Header headerFixed={headerFixed} />
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <main className='w-100 image-cover h-100' style={{ minHeight: '100vh' }}>
        <section
          className={`container-fluid ${containerFullWidth ? 'mx-0 px-0' : ''}`}
        >
          <div className='row mx-0'>
            {showSidebar && (
              <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 my-2'>
                <Sidebar />
                {showFormSidebar && sidebarComponent}
              </div>
            )}
            <div
              className={`${
                showSidebar
                  ? 'col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 bg-sky-light shadow-sm rounded-1 my-3'
                  : 'w-100'
              }`}
            >
              {children}
            </div>
          </div>
        </section>
        {pathname === '/' && (
          <div style={{ position: 'fixed', right: '5px', bottom: '10px' }}>
            <a
              referrerPolicy='origin'
              target='_blank'
              href='https://trustseal.enamad.ir/?id=284463&amp;Code=iSl2HI9TvNC7aCw5kyih'
            >
              <img
                referrerPolicy='origin'
                src='https://Trustseal.eNamad.ir/logo.aspx?id=284463&amp;Code=iSl2HI9TvNC7aCw5kyih'
                alt=''
                style={{ cursor: 'pointer' }}
                id='iSl2HI9TvNC7aCw5kyih'
              />
            </a>
          </div>
        )}
      </main>
      <div className='d-md-none' style={{ paddingBottom: '70px' }}></div>
      <FooterMobile logout={logout} auth={check} />
    </>
  );
};

Master.propTypes = {
  showSidebar: PropTypes.bool,
  containerFullWidth: PropTypes.bool,
};

export default Master;
